<template>
  <div class="add-data">
    <div @click="centerDialogVisible = true" class="add-btn">添加</div>

    <el-dialog :closeOnClickModal='false' title="教材" :modal-append-to-body='false' :visible.sync="centerDialogVisible"
      width="800px">
      <div class="edit-context" style="min-width:650px;">

        <div class="edit-inp">
          <el-form :rules="rules" ref="form" :model="form" label-width="110px">

            <div class="item-box">
              <el-form-item label="应用类型：" prop="edition">
                <el-select v-model="form.edition" placeholder="请选择应用类型">
                  <el-option v-for="item in selectDict.edition" :key="item.id" :label="item.name" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div>

            <!-- <div class="item-box">
              <el-form-item label="授权：" prop="toll">
                <el-select v-model="form.toll" placeholder="请选择计费方式">
                  <el-option v-for="item in payment" :key="item.label+item.name" :label="item.label" :value="item.name">
                  </el-option>
                </el-select>
              </el-form-item>
            </div> -->

            <el-form-item label="是否公开：" prop="openState">
              <el-radio-group v-model="form.openState">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="2">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="附件上传：" style="padding-right:15px">
              <div class="upload-box">
                <el-upload class="upload-demo" :before-upload='beforeUpload' :auto-upload='true' action
                  :http-request="uploadSectionFile" accept=".apk" :on-remove="handleRemove" :limit="1"
                  :on-exceed="handleExceed">

                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传apk文件，且不超过50MB</div>
                </el-upload>
              </div>
            </el-form-item>
          </el-form>

          <div class="handleBtn">
            <button class="primary" @click.prevent="onSubmit(form)">确认</button>
            <button class="default" @click="closeBtn">取消</button>
          </div>
        </div>

        <div v-if="isPercentage" class="percentage-box">
          <el-progress color='#24ba58' type="circle" :percentage="percentageNum"></el-progress>
        </div>

      </div>

    </el-dialog>

  </div>
</template>

<script>
import utils from "@/util/index";
import {
  ossUpload,
  getUploadPolicies,
  addTextbook
} from "@/network/resourceRequest/api";
import util from "@/util/index";
export default {
  name: "AddApplication",
  props: {
    selectDict: {
      default() {
        return {};
      }
    }
  },

  data() {
    return {
      //是否关闭添加窗口
      centerDialogVisible: false,
      //文件信息
      form: {
        name: "", //教材名称
        course: "", //科目
        phase: "", //学段
        grade: "", //年级
        volume: "", //册别
        edition: "", //出版社
        label: "", //教材性质
        toll: "", //是否收费
        openState: 1, //公开状态
        fileId: "", //文件id凭证
        fileIdList: [], //文件id列表
        coverId: "", //封面id凭证
        id: 0, //资源id
        label: "" //标签属性
      },

      //表单校验规则
      rules: {},

      //计费方式--------------------------------------------
      payment: [
        {
          name: 1,
          label: "免费"
        },

        {
          name: 2,
          label: "收费"
        }
      ],

      //上传的文件信息(用于获取)--------------------------------------------
      fileInfoList: [],
      //文件id列表--------------------------------------------
      fileIdList: [],
      //上传成功文件数
      uploadFileNum: [],
      //当前进度
      currentUploadList: [],
      //总上传大小
      totalUpload: 0,

      //是否显示百分比状态
      isPercentage: false
    };
  },

  created() {
    //初始化校验规则
    this.checkRule();
  },

  methods: {
    //初始化校验规则
    checkRule() {
      //校验名称
      let validateName = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入教材名称"));
        } else {
          callback();
        }
      };
      //提示规则  //下拉选择框可以默认选择第一个
      this.rules = {
        name: [{ validator: validateName, trigger: "blur" }],
        course: [{ required: true, message: "请选择科目", trigger: "change" }],
        phase: [{ required: true, message: "请选择学段", trigger: "change" }],
        grade: [{ required: true, message: "请选择年级", trigger: "change" }],
        volume: [{ required: true, message: "请选择册别", trigger: "change" }],
        edition: [
          { required: true, message: "请选择出版社", trigger: "change" }
        ],
        label: [
          { required: true, message: "请选择教材性质", trigger: "change" }
        ],
        toll: [
          { required: true, message: "请选择授权方式", trigger: "change" }
        ],
        openState: [
          { required: true, message: "请选择公开状态", trigger: "change" }
        ]
      };
    },

    //表单校验是否通过--------------------------------------------
    formVerification(form) {
      let falg = "";
      this.$refs.form.validate(valid => {
        if (valid) {
          falg = true;
        } else {
          falg = false;
        }
      });
      return falg;
    },

    //关闭窗口按钮--------------------------------------------
    closeBtn() {
      this.centerDialogVisible = false;
    },

    //上传前校验--------------------------------------------
    beforeUpload(file) {
      let fileName = file.name.lastIndexOf("."); //取到文件名开始到最后一个点的长度
      let fileNameLength = file.name.length; //取到文件名长度
      let fileFormat = file.name.substring(fileName + 1, fileNameLength); //截取
      switch (fileFormat) {
        case "apk":
          break;
        default:
          utils.tips("warning", "非法类型，只支持apk");
          return false;
          break;
      }
    },

    //1.自定义上传文件功能（获取文件信息）--------------------------------------------
    uploadSectionFile(params) {
      if (this.fileInfoList.length == 0) {
        //没有文件时
        //获取文件大小
        this.totalUpload += params.file.size;
      } else {
        //更换文件时
        this.totalUpload += params.file.size;
      }

      let data = {
        filename: params.file.name, //文件名,
        size: params.file.size, //文件大小
        space: "RESOURCE", //文件存储空间,可选:RESOURCE,COMMON,ICON
        file: params.file,
        params
      };
      this.fileInfoList = [];
      this.fileInfoList.push(data);
    },

    //2.确定上传--------------------------------------------
    onSubmit(form) {
      //校验表单是否通过再去上传
      let flag = this.formVerification(form);
      if (flag) {
        //上传文件;
        if (this.fileInfoList.length == 0)
          return utils.tips("warning", "请您添加应用");
        this.uploadFile();
      } else {
        utils.tips("warning", "请您完善信息");
      }
    },

    //3.上传文件--------------------------------------------
    uploadFile() {
      //展示加载进度
      this.isPercentage = true;
      // 上传文件--------------------------------------------
      this.fileInfoList.forEach(item => {
        this.currentUploadList.push(0);
        this.getPolicie(item, "file", 0);
      });
    },

    //4.获取上传凭证--------------------------------------------
    async getPolicie(data, type, index) {
      //获取凭证--------------------------------------------
      let policie = await getUploadPolicies(data);
      let result = policie.data.data;
      let fd = new FormData();
      fd.append("key", result.path); //
      fd.append("OSSAccessKeyId", result.accessid); //
      fd.append("policy", result.policy); //
      fd.append("signature", result.signature); //签名
      fd.append("success_action_status", 200); //
      fd.append("file", data.file); //
      // 上传阿里云--------------------------------------------;
      ossUpload(result.host, fd, this.uploadCallback, index).then(
        res => {
          //上传阿里云成功后--------------------------------------------
          if (res.status == 200) {
            switch (type) {
              //文件--------------------------------------------
              case "file":
                // 文件列表id
                this.fileIdList.push(result.fileId);
                // 文件id
                this.$set(this.form, "fileId", this.fileIdList[0]);
                //上传成功的数组--------------------------------------------
                this.uploadFileNum.push(result.fileId);
                break;
            }
          } else {
            console.log("AddETextBook=>上传阿里云失败");
          }
        },
        error => {
          console.log(error);
        }
      );
    },

    //上传回调--------------------------------------------
    uploadCallback(progressEvent, index) {
      this.currentUploadList.splice(index, 1, progressEvent.loaded);
    },

    //删除文件--------------------------------------------
    handleRemove(file) {
      this.fileInfoList.forEach((item, index) => {
        if (item.file.uid == file.uid) {
          //删除对应的文件大小
          this.totalUpload -= item.file.size;
          this.fileInfoList.splice(index, 1);
          this.$set(this.form, "fileId", this.fileInfoList[0]);
        }
      });
    },

    //限制上传的文件数量--------------------------------------------
    handleExceed(files, fileList) {
      utils.tips("warning", `只能上传一个应用`);
    }
  },

  watch: {
    //5.给后台明确添加成功
    uploadFileNum(newVal) {
      //当上传成功的数量等于文件和封面的数量时  提交给后台说明教材添加成功
      if (newVal.length == this.fileInfoList.length) {
        this.$set(this.form, "fileIdList", this.fileIdList);
        addTextbook(this.form).then(res => {
          if (res.data.success) {
            //关闭加载进度
            this.isPercentage = false;
            utils.tips("success", "上传成功");
            //关闭窗口
            this.closeBtn();
            this.$emit("addSuccess");
          }
        });
      }
    }
  },

  computed: {
    //进度条
    percentageNum() {
      let currentUpload = 0;
      this.currentUploadList.forEach(item => {
        currentUpload += item;
      });
      return ((currentUpload / this.totalUpload) * 100) | 0;
    }
  }
};
</script>

<style lang="less" scoped>
.add-data {
  user-select: none;
  position: relative;

  width: 100%;
  height: 20px;

  .percentage-box {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.2);

    /deep/ .el-progress__text {
      color: #24ba58 !important;
    }
  }

  .add-btn {
    position: absolute;
    top: -15px;
    left: 0;

    border-radius: 5px;
    width: 60px;
    height: 30px;

    font-size: 16px;
    line-height: 30px;
    text-align: center;

    color: #fff;
    background-color: #24ba58;

    cursor: pointer;
    user-select: none;

    &:hover {
      box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.2);

      transform: translateY(-1px);
    }
  }

  /deep/ .el-dialog {
    overflow: hidden;

    border-radius: 5px;

    // 头部
    .el-dialog__header {
      padding: 20px;

      background-color: #24ba58;

      .el-dialog__title {
        color: #fff;

        user-select: none;
      }

      .el-dialog__close {
        font-size: 20px;

        color: #fff;
      }
    }

    //内容
    .el-dialog__body {
      .item-box {
        display: flex;

        .el-form-item {
          flex: 1;
        }
      }

      .upload-box {
        .avatar-uploader .el-upload {
          overflow: hidden;

          position: relative;

          border: 1px dashed #d9d9d9;
          border-radius: 6px;

          cursor: pointer;
        }
        .avatar-uploader .el-upload:hover {
          border-color: #409eff;
        }
        .avatar-uploader-icon {
          position: relative;

          width: 100px;
          height: 100px;

          font-size: 28px;
          line-height: 100px;
          text-align: center;

          color: #8c939d;

          div {
            display: flex;

            position: absolute;
            top: 0;
            left: 0;

            padding-left: 4px;
            width: 100%;

            letter-spacing: 5px;

            justify-content: space-between;
          }
        }
        .avatar {
          display: block;

          width: 100px;
          height: 100px;
        }
      }
    }

    .handleBtn {
      display: flex;

      align-items: center;
      justify-content: center;

      button {
        margin: 0 100px;
        border: 1px solid #24ba58;
        border-radius: 5px;
        width: 80px;
        height: 40px;

        font-size: 14px;
        line-height: 40px;
        text-align: center;
        letter-spacing: 5px;

        color: #fff;
        background-color: #24ba58;

        outline: none;

        transition: all 0.3s;

        cursor: pointer;

        &:hover {
          box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);

          transform: translateY(-1px);
        }
      }
    }
  }
}
</style>